import { ModulePrefixes } from "enums";
import { useSearch } from "helpers";
import { t } from "i18next";
import LeftMenuCard from "leftMenu/LeftMenuCard";
import { useLocation } from "react-router-dom";
import { featureMenu } from "staticData";

export default function FeatureMenu(props) {
  const { search } = useLocation();
  const { web } = useSearch();

  return (
    <>
      <div className="card-div">
        {featureMenu(web).map((item, index) => (
          <LeftMenuCard
            key={`${index}-${item.module}`}
            {...item}
            title={t(item.title)}
            prefix={web ? ModulePrefixes.SITE_SETTINGS: ModulePrefixes.SITE_TEMPLATE}
            link={`${web ? ModulePrefixes.SITE_SETTINGS: ModulePrefixes.SITE_TEMPLATE}/${item.module}${
              search ?? ""
            }`}
          />
        ))}
      </div>
    </>
  );
}
